import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Col, ControlLabel } from 'react-bootstrap';
import formatNumbers  from 'util/formatNumbers';
import { sendDataForIframe}  from 'shared/sharedMethods';
 import config from  '../../config';
import {makeRequest, dispatchAction, displayMessage}  from 'actions';
import {  UPDATE_SELLER } from 'actions/actionTypes';
import moment from 'moment';
import PhoneInput from 'shared/PhoneInput/PhoneInput.js'
import { calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';


class SellerSettingsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            PaymentMethod: _.find(_.concat(config.allPaymentMethodOptions, [{
                value: 'Donate',
                label: 'Donate'
            }]), {value: _.get(this.props.userReducer.seller, ['PaymentMethod',], 'GoodBuyBucks')}),
            PaymentData: _.get(this.props.userReducer.seller, ['PaymentData'], ''),
            Paypal: _.get(this.props.userReducer.seller, ['PaymentData', 'Paypal', 'email'], ''),
            errors: {},
            pending: false,
            OrganizationList: 'initial',
            totalPayoutAmount: 'initial',
            totalShopifyOrdersAmount: 'initial',
            totalSellerProductsNumber: 'initial',
            totalSellerTransactionsNumber: 'initial'
        }
        this.pageContent = false;
    }

    componentWillMount() {
        var self = this;
        if (_.get(this.props.userReducer.seller, ['PaymentMethod'], '') == 'Donate') {
            this.getOrganizationList(function () {
                self.setState({Organization: _.find(_.concat(config.donationOrganizations, self.state.OrganizationList), {value: _.get(self.props.userReducer.seller, ['PaymentData', 'Donate', 'email'], '')})})
            })
        }

            this.getSellerTransactions()
            this.getSellerShopifyOrders()
            this.getSellerProducts()

    }

    componentDidMount() {

    }



    getSellerShopifyOrders() {


        this.props.makeRequest({
            ShopifyOrders: true,
            all:true,
            getAllShopifyOrders:true,
            ShopifyCustomerID: this.props.userReducer.user.ShopifyCustomerID
        }, {
            'endpoint': '/shopify_orders',
            'not_display_success_message': true,
        }).then(res => {
            console.log('shopify orders', res.data);

            if (_.size(_.get(res.data, 'data', []))) {
                var totalShopifyOrdersAmount = _.reduce(_.get(res.data, 'data', []), function (total, order) {
                    if (_.get(order, 'total_price')) {

                        total += formatNumbers.unformat(formatNumbers.toFixed(order.total_price, 2))

                    }
                    return total
                }, 0)

                if (totalShopifyOrdersAmount <0){
                    totalShopifyOrdersAmount = 0
                }
                this.setState({
                    totalShopifyOrdersAmount: totalShopifyOrdersAmount,
                });
            }
        })
    }

    getSellerTransactions() {
        var self = this;
        this.props.makeRequest({all: true,
            Statuses: ["Paid","Sold", "Pending", "PendingPayout"],
            include:['SaleData', 'Amount','Type'],
            SellerID: this.props.userReducer.seller._id}, {
            'endpoint': '/transactions',
            'not_display_success_message': true,
        }).then(res => {
            this.setState({sellerTransactions: _.get(res.data, 'data', [])}, function () {
                if (_.size(self.state.sellerTransactions)) {
                    var totalPayoutAmount = _.reduce(self.state.sellerTransactions, function (totalPayout, transaction) {
                        if (transaction.Type == 'Sale') {
                            if (_.isUndefined(transaction.SaleData.PayoutPercentage)) {
                                return totalPayout
                            }

                            totalPayout += calculateTransactionPayoutAmount(transaction,  self.props.appData.FeatureFlags);
                        } else if (transaction.Type == 'Credit') {
                           totalPayout += transaction.Amount
                        } else if (transaction.Type == 'Fee' || transaction.Type == 'PickupFee') {
                           totalPayout -= transaction.Amount
                        }
                        return totalPayout
                    }, 0)
                    if (totalPayoutAmount <0){
                        totalPayoutAmount = 0
                    }
                    self.setState({
                        totalPayoutAmount:  formatNumbers.unformat(formatNumbers.toFixed(totalPayoutAmount, 2)),
                        totalSellerTransactionsNumber: _.size(_.filter(self.state.sellerTransactions, {Type: 'Sale'}))
                    })
                }

            })
        })
    }

    getSellerProducts() {
        this.props.makeRequest({
            all: true,
            projectQuery: ['_id'],
            SellerID: this.props.userReducer.seller._id
        }, {
            'endpoint': '/products',
            'not_display_success_message': true,
        }).then(res => {
            if (_.size(_.get(res.data, 'data', []))) {
                this.setState({
                    totalSellerProductsNumber: _.size(_.get(res.data, 'data', []))
                });
            }
            // else {
            //     this.setState({
            //         totalSellerProductsNumber: 'n/a',
            //     })
            // }
        })
    }

    getOrganizationList(callback) {
        if (this.state.OrganizationList !== 'initial' && _.size(this.state.OrganizationList) > 0) { /* organization list already received */
            return callback()
        }
        var methodData = {
            'endpoint': '/organizations',
            'not_display_success_message': true,
        };

        this.props.makeRequest({}, methodData).then(res => {

            this.setState({
                OrganizationList: res.data.OrganizationList,
            }, function () {
                callback()
            });
        })
    }


    validateAndPrepareSellerData() {
        var formData = {}
        formData.PaymentMethod = _.get(this.state.PaymentMethod, ['value'], '')
        if (!formData.PaymentMethod) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSelected',
                messageData: {'#1#': 'payment method'}
            });
            return false
        }
        if (formData.PaymentMethod == 'Donate') {
            var organizationID = _.get(this.state.Organization, ['value'], '')
            if (!organizationID) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldNotSelected',
                    messageData: {'#1#': 'organization to donate to'}
                });
                return false
            }
            formData['PaymentData'] = {'Donate': {'email': organizationID}}
        } else if (formData.PaymentMethod == 'Paypal') {
            if (!this.state.Paypal) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'errorFieldNotSpecified',
                    messageData: {'#1#': 'Payment account'}
                });
                return false
            }
            formData['PaymentData'] = {'Paypal': {'email': this.state.Paypal}}
        }
        return formData
    }

    updateSellerData(e) {
        var self = this;

        this.setState({pending: true});
        var userFormData = this.validateAndPrepareSellerData();
        if (!userFormData) {
            this.setState({pending: false});
            return false;
        }
        var methodData = {
            success_event: UPDATE_SELLER,
            type: 'patch',
            endpoint: '/sellers/' + encodeURIComponent(this.props.userReducer.seller._id),
            messageData: {'#1#': 'Record'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(userFormData, methodData).then(function (response) {
            self.setState({pending: false});
        }).catch(e => {
            self.setState({pending: false});
        })
    }

    displayPayoutMethodInput() {
        var self = this, selectPlaceholder = 'Donate to'

        return <div className="top20">
            <Col className="bot10 pleft0 pright0 left0" xs={12} sm={6} md={6} lg={4}>


                <h4 className="left0">
                    Payment Method: {_.get(this.state.PaymentMethod, ['value'], '')}
                </h4>
            </Col>
            { _.get(this.state.PaymentMethod, ['value'], '') == 'Paypal' &&
            <div className=" ">
                <Col
                    className="pleft0 pright0 "  //input-styled bot30
                    xs={12} sm={6} md={6} lg={4}>
                    {/*<FormControl*/}
                    {/*style={this.state.errors['Paypal'] ? {border: '1px solid red'} : {} }*/}
                    {/*onFocus={(e) => this.setState({*/}
                    {/*errors: {*/}
                    {/*...this.state.errors,*/}
                    {/*Paypal: false*/}
                    {/*}*/}
                    {/*}) }*/}
                    {/*className={this.state.Paypal ? 'active' : ''}*/}
                    {/*defaultValue={this.state.Paypal}*/}
                    {/*onChange={(e) => this.setState({*/}
                    {/*Paypal: e.target.value*/}
                    {/*} ) }*/}
                    {/*type="text"/>*/}
                    <h4 className="left0">
                        {this.state.Paypal}
                    </h4>
                </Col>
            </div>
            }
            {_.get(this.state.PaymentMethod, ['value'], '') == 'Donate' && _.size(this.state.OrganizationList) > 0 &&
            <div className=" ">
                <Col className="input-styled  pleft0 pright0 bot30" xs={12} sm={6} md={6} lg={6}>
                    <h4>Organization: {_.get(this.state.Organization, 'label', '') }</h4>

                    {/*<Select*/}
                    {/*style={this.state.errors['Organization'] ? {border: '1px solid red'} : {} }*/}
                    {/*onFocus={(e) => this.setState({*/}
                    {/*errors: {*/}
                    {/*...this.state.errors,*/}
                    {/*Organization: false*/}
                    {/*}*/}
                    {/*}) }*/}
                    {/*searchable={ false}*/}
                    {/*valueComponent={customSelectValue.bind(this)}*/}
                    {/*className={ classNames({*/}
                    {/*'with-custom-value': this.state.Organization,*/}
                    {/*})}*/}
                    {/*clearable={false}*/}
                    {/*selectedOptions*/}
                    {/*placeholder={selectPlaceholder}*/}
                    {/*options={ _.concat(config.donationOrganizations, this.state.OrganizationList )}*/}
                    {/*onChange={ (option) => {*/}
                    {/*this.setState({'Organization': option ? option : false});*/}
                    {/*}}*/}
                    {/*value={this.state.Organization}*/}
                    {/*/>*/}
                </Col>
            </div>
            }
            <div className="clearfix"></div>
        </div>
    }



    displayPhoneNumberInput() {
        return <Col className="bot30" xs={12} sm={6} md={6} lg={4}>
            <ControlLabel >
                Cell Phone Number  (for text reminders)
            </ControlLabel>
            <PhoneInput defaultCountry={'us'}
                        onlyCountries={['us']}
                        onChange={ (value) => this.setState({
                            PhoneNumber: value
                        })}
                        value={this.state.PhoneNumber}
                        inputStyle={this.state.errors['PhoneNumber'] ? {border: '1px solid red'} : {} }
                        onFocus={(e) => {
                            this.setState({
                                errors: {
                                    ...this.state.errors,
                                    PhoneNumber: false
                                }
                            })
                        } }
            />
        </Col>
    }


    render() {

        if (_.get(this.props.userReducer.seller, ['PaymentMethod'], '') == 'Donate' && this.state.OrganizationList == 'initial') {
            return null
        }

        if(this.props.appData.FeatureFlags.initialData) {
            return null;
        }
        return (
            <div className="seller-settings-page" ref={ page => {
                if(page && !this.pageContent) {
                    this.pageContent = page;
                    sendDataForIframe.call(this, 'sellerData')
                }
            }}>
                <div className="settings-row-wrapper">
                    <div className="settings-row">
                        <div className="settings-row__box">
                            <span
                                className="settings-row__box-value">{ this.state.totalPayoutAmount == 'initial' ? '' : (( this.state.totalPayoutAmount >= 0 ? '' : '-') + formatNumbers.formatMoney(formatNumbers.toFixed(Math.abs(this.state.totalPayoutAmount), 2))) }</span>
                            <img className="settings-row__box-image"
                                 src={(config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') + '/theme/assets/money.png'}/>
                            <span
                                className="settings-row__box-label">The money you have made selling with GoodBuy Gear</span>
                        </div>

                        <div className="settings-row__box">
                            <span
                                className="settings-row__box-value">{ this.state.totalShopifyOrdersAmount == 'initial' ? '' : formatNumbers.formatMoney(formatNumbers.toFixed(this.state.totalShopifyOrdersAmount, 2)) }</span>
                            <img className="settings-row__box-image"
                                 src={(config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') + '/theme/assets/piggybank.png'}/>
                            <span
                                className="settings-row__box-label">The money you have saved buying with GoodBuy Gear</span>
                        </div>

                    </div>
                    <div className="settings-row">
                        <div className="settings-row__box">
                            <span
                                className="settings-row__box-value">{ this.state.totalSellerProductsNumber == 'initial' ? '' : this.state.totalSellerProductsNumber }</span>
                            <img className="settings-row__box-image"
                                 src={(config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') + '/theme/assets/recycle.png'}/>
                            <span
                                className="settings-row__box-label">The number of items you have saved from the landfills</span>
                        </div>


                        <div className="settings-row__box">
                            <span
                                className="settings-row__box-value">{ this.state.totalSellerTransactionsNumber == 'initial' ? '' : this.state.totalSellerTransactionsNumber  }</span>
                            <img className="settings-row__box-image"
                                 src={(config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') + '/theme/assets/family.png'}/>
                            <span className="settings-row__box-label">The number of families you have helped</span>
                        </div>
                    </div>
                </div>

                 {/*{this.displayPayoutMethodInput()}*/}


                {/*<FormGroup>*/}
                {/*<Col xs={12}>*/}
                {/*<Button className="btn btn-primary " onClick={(event) => this.updateSellerData()}>*/}
                {/*Save*/}
                {/*</Button>*/}
                {/*</Col>*/}


            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        appData: state.appData,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SellerSettingsPage);
